import { CCGLMinAge, DeafCampMinAge, DeafCampMaxAge, JuniorCampMinAge, JuniorCampMaxAge, YouthCampMinAge, YouthCampMaxAge } from "../Constants/EventCamperAges"

const DataAccessHelper = {

   // Searches open registrations for those of type free deaf week
   searchForPreexistingFreeDeafCampRegistration: async function (guestId) {

      var freeCampExistsRequest = await fetch('/searchexistingfreedeafregistration', {
         method: 'POST',
         headers: { "Content-Type": "application/json" },
         body: JSON.stringify({
            guestId
         })
      })

      const freeCampExistsResponse = await freeCampExistsRequest.json()
      console.log('free camp exists', freeCampExistsResponse)
      if (freeCampExistsResponse.data.existsQuery != '') {
         return true
      }
      else {
         return false
      }
   },

   // Returns fast track reservation for the given group registration
   getFastTrackInformation: async function (reservationId) {
      try {
         var fastTrackRequest = await fetch('/getselectedfasttrack', {
            method: 'POST',
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
               reservationId
            })
         })

         var fastTrackResponse = await fastTrackRequest.json()

         return fastTrackResponse;
      } catch (error) {
         console.log(error)
      }
   },

   getStandardReservationInformation: async function (reservationId) {
      try {
         var fastTrackRequest = await fetch('/getselectedstandardreservation', {
            method: 'POST',
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
               reservationId
            })
         })

         var standardReservationResponse = await fastTrackRequest.json()

         return standardReservationResponse;
      } catch (error) {
         console.log(error)
      }
   },

   // Determine if guest is a valid church counselor or group leader
   DetermineIfCCOrGLIsValidAgeForGuestSelecting: function (guestAge) {
      let isValid = true
      if (guestAge < CCGLMinAge) {
         isValid = false
      }
      return isValid
   },

   DetermineIfCamperIsValidAgeForGuestSelecting: function (campType, guestAge) {
      let isValid = true
      if (campType == 'Youth Camp') {
         if (guestAge < YouthCampMinAge || guestAge > YouthCampMaxAge) {
            isValid = false
         }
      }
      if (campType == 'Junior Camp') {
         if (guestAge < JuniorCampMinAge || guestAge > JuniorCampMaxAge) {
            isValid = false
         }
      }
      if (campType == 'Deaf Camp') {
         if (guestAge < DeafCampMinAge || guestAge > DeafCampMaxAge) {
            isValid = false
         }
      }
      return isValid
   },

   // Get current guest Id
   getCurrentAccountInformation: async function () {
      try {

         const individualAccountResponse = await fetch('/api/get-user', {
            method: 'GET',
            headers: { "Content-Type": "application/json" }
         })

         if (individualAccountResponse.status === 400 || individualAccountResponse.status === 500) {
            throw new Error("Failed User Retrieval");
         }

         const account = await individualAccountResponse.json();
         console.log("here's account", account)
         return account
      }
      catch (error) {
         console.log(error)
      }
   },
   // Determine a camp week's vacancy status

   determineVacancyStatus: async function (event) {
      try {
         let vacancyStatus;

         // Check event number of slots
         if (event.number_of_slots > 0) {
            vacancyStatus = 'Vacancy'
         }
         else {
            // Get registrations with fast track for given event
            var registrationRequest = await fetch('/getfasttrackregistrationsbyeventid', {
               method: 'POST',
               headers: { "Content-Type": "application/json" },
               body: JSON.stringify({
                  eventId: event.event_id
               })
            })
            let registrationResponse = await registrationRequest.json()
            let registrations = registrationResponse.data.registrations

            // Get the sum of available fast track slots.
            let fastTrackSlots = 0
            for (let r = 0; r < registrations.length; r++) {
               let registration = registrations[r]
               let registId = registration.regist_id
               let fastTrackRequest = await fetch('/getselectedfasttrack', {
                  method: 'POST',
                  headers: { "Content-Type": "application/json" },
                  body: JSON.stringify({
                     registId
                  })
               })
               let fastTrackResponse = await fastTrackRequest.json()
               fastTrackSlots += fastTrackResponse.data.eventInfo[0].slots_reserved
            }
            if (fastTrackSlots > 0) {
               vacancyStatus = 'Vacancy limited to select groups'
            }
            else {
               vacancyStatus = "Week full"
            }
         }
         return vacancyStatus

      } catch (error) {
         console.log(error)
      }
   }
}
export default DataAccessHelper
